import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EmptyOptionType } from 'src/components/atomic/Molecules/EmptyComponent'

export type ExplorerPageStateType = {
  EmptyComponentStatus: EmptyOptionType
  ExplorerDeleteCheckList: boolean[]
  ExplorerFileDownCancelToggle: boolean
  ExplorerStorageLoading: boolean
  ExplorerFileListLoading: boolean
}

const initialState: ExplorerPageStateType = {
  EmptyComponentStatus: 'default',
  ExplorerDeleteCheckList: [false, false, false, false],
  ExplorerFileDownCancelToggle: false,
  ExplorerStorageLoading: false,
  ExplorerFileListLoading: false
}

const ExplorerPageSlice = createSlice({
  name: 'ExplorerPage',
  initialState,
  reducers: {
    setEmptyComponentStatus(state, action: PayloadAction<EmptyOptionType>) {
      state.EmptyComponentStatus = action.payload
    },
    ResetExplorerDeleteCheckList(state) {
      state.ExplorerDeleteCheckList = [false, false, false, false]
    },
    setExplorerDeleteCheckList(state, action) {
      state.ExplorerDeleteCheckList = action.payload
    },
    setExplorerFileDownCancelToggle(state, action) {
      state.ExplorerFileDownCancelToggle = action.payload
    },
    setExplorerStorageLoading(state, action: PayloadAction<boolean>) {
      state.ExplorerStorageLoading = action.payload
    },
    setExplorerFileListLoading(state, action: PayloadAction<boolean>) {
      state.ExplorerFileListLoading = action.payload
    },
  },
})

export const {
  setEmptyComponentStatus,
  setExplorerFileDownCancelToggle,
  setExplorerDeleteCheckList,
  ResetExplorerDeleteCheckList,
  setExplorerStorageLoading,
  setExplorerFileListLoading,
} = ExplorerPageSlice.actions

export default ExplorerPageSlice.reducer
